export const SLIP_DETAIL = "SLIP_DETAIL"
export const SLIP_DETAIL_SUCCESS = "SLIP_DETAIL_SUCCESS"
export const SLIP_DETAIL_ERROR = "SLIP_DETAIL_ERROR"

export const SLIP_SELECT = "SLIP_SELECT"
export const SLIP_SELECT_SUCCESS = "SLIP_SELECT_SUCCESS"
export const SLIP_SELECT_ERROR = "SLIP_SELECT_ERROR"

export const SLIP_UPDATE = "SLIP_UPDATE"
export const SLIP_UPDATE_SUCCESS = "SLIP_UPDATE_SUCCESS"
export const SLIP_UPDATE_ERROR = "SLIP_UPDATE_ERROR"

export const SLIP_QR_UPDATE = "SLIP_QR_UPDATE"
export const SLIP_QR_UPDATE_SUCCESS = "SLIP_QR_UPDATE_SUCCESS"
export const SLIP_QR_UPDATE_ERROR = "SLIP_QR_UPDATE_ERROR"
